import supportModule from '../supportModule';

function supportForm(resources) {
  'ngInject';

  return {
    restrict: 'A',
    scope: true,
    replace: true,
    templateUrl: resources.templateUrls.supportForm
  };
}

supportModule.directive('supportForm', supportForm);

export default supportForm;